import { ConfigurationBillableConceptGroupsModalState, initialConfigurationBillableConceptGroupsModalState } from '@/modules/configurationModule/detail/accounting/billable/groups-of-concepts/components/modal-basic-form/conceptgroups-modal-basic-form.model'
import { ConfigurationBillableConceptGroupCreateRequest, ConfigurationBillableConceptGroupPatchInBatchRequest, ConfigurationBillableConceptGroupResponse } from '@/modules/configurationModule/detail/accounting/billable/groups-of-concepts/services/configuration-billable-concept-group.dto'
import { Nullable } from '@/shared/types/app.types'
import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class ConceptGroupsModalBasicForm extends Vue {
    state: ConfigurationBillableConceptGroupsModalState
    @Ref() readonly conceptGroupsModal!: any
    @Prop(String) readonly actionTitle!: string

    constructor() {
        super()
        this.state = initialConfigurationBillableConceptGroupsModalState()
    }

    @Emit()
    create(): ConfigurationBillableConceptGroupCreateRequest {
        return {
            name: this.state.name,
            code: this.state.code,
            active: this.state.active
        }
    }

    @Emit()
    update(): ConfigurationBillableConceptGroupPatchInBatchRequest {
        return {
            id: this.state.id ?? 0,
            name: this.state.name,
            code: this.state.code,
            active: this.state.active
        }
    }

    async show(selectedRow: Nullable<ConfigurationBillableConceptGroupResponse>): Promise<void> {
        await this.initializeConceptGroup(selectedRow)
        this._showModal()
    }

    private _showModal(): void {
        this.conceptGroupsModal.show()
    }

    async initializeConceptGroup(concept: Nullable<ConfigurationBillableConceptGroupResponse>): Promise<void> {
        this.state = initialConfigurationBillableConceptGroupsModalState()
        await this.$validator.reset()
        if (concept) {
            this.state.id = concept.id
            this.state.name = concept.name
            this.state.code = concept.code
            this.state.active = concept.active
        }
    }

    get updateMode(): boolean {
        return !!this.state.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.updateMode) {
                this.update()
            } else {
                this.create()
            }
        }
    }

    hide(): void {
        this.conceptGroupsModal.hide()
    }
}
